function accordionTrigger() {

	
};

module.exports = accordionTrigger;